import { useEffect } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { programs } from "@/mocks/programs";
import { useTranslatedList } from "@/hooks/useTranslatedList";
import Reveal from "@/components/base/Reveal";

export default function ProgramsPage() {
  const { t } = useTranslation();
  const translatedPrograms = useTranslatedList(programs, ["name", "description", "category"]);

  useEffect(() => {
    document.title = "Programs | L+TV TÉLÉVISION";
  }, []);

  return (
    <div className="pt-20">
      <div className="bg-primary-900 py-8">
        <div className="ltv-container">
          <Reveal direction="up">
            <h1 className="text-2xl md:text-3xl font-bold text-white">{t("programs.title")}</h1>
            <p className="text-white/60 text-sm mt-1">{t("programs.subtitle")}</p>
          </Reveal>
        </div>
      </div>

      <div className="ltv-container py-8 md:py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {translatedPrograms.map((program, index) => (
            <Reveal key={program.id} direction="up" delay={(index % 3) * 80}>
              <Link to={`/programs/${program.slug}`} className="ltv-card group h-full block">
                <div className="relative aspect-[16/10] overflow-hidden">
                  <img
                    src={program.image}
                    alt={program.name}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute top-3 left-3">
                    <span className="bg-primary-500 text-white text-xs font-semibold px-2 py-1 rounded">
                      {program.category}
                    </span>
                  </div>
                  <div className="absolute bottom-3 right-3">
                    <span className="bg-black/60 text-white text-xs font-medium px-2 py-1 rounded">
                      {program.duration}
                    </span>
                  </div>
                </div>
                <div className="p-4">
                  <h3 className="font-semibold text-foreground-900 leading-snug mb-1 group-hover:text-accent-600 transition-colors">
                    {program.name}
                  </h3>
                  <p className="text-sm text-foreground-600 line-clamp-2 mb-2">
                    {program.description}
                  </p>
                  <div className="flex items-center gap-2 text-xs text-foreground-500">
                    <i className="ri-user-line"></i>
                    <span>{program.presenter}</span>
                  </div>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  );
}